// extracted by mini-css-extract-plugin
export default {"header":"Paginapadrao_header__sMDVl","header__text":"Paginapadrao_header__text__CBykU"};